module.exports = __webpack_public_path__ + "static/shape-e808338f2af8b7bef484159b4189c1c6.png";